import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { useOperatorActions } from "../../../../utils/useOperatorActions";
import CyberBoxComponent from "../../../shared/ui/layout/CyberBoxComponent";
import { AhangariHoldingLogoDisplayComponent } from "../../../shared/ui/logo-display/ahangariHoldingLogoDisplayComponent";
import { HotLogoDisplayComponent } from "../../../shared/ui/logo-display/HotLogoDisplayComponent";
import { WelcomeComponent } from "./../day-1/components/welcomeComponent";
import MondfxLogoDisplayComponent from "../../../shared/ui/logo-display/MondfxLogoDisplayComponent";
import FenefxLogoDisplayComponent from "../../../shared/ui/logo-display/FenefxLogoDisplayComponent";
import FirtChallangeLeaderBoardTableComponent from "./../day-1/components/FirtChallangeLeaderBoardTableComponent";
import PreviousChallangeLeaderBoardTableComponent from "./../day-1/components/PreviousChallangeLeaderBoardTableComponent";
import ResultTableComponent from "./../day-1/components/ResultTableComponent";
import TeamLoaderBoardComponent from "../day-3/components/teamLeaderBoardComponent";
import TransformMarketTableComponent from "./components/transofrmMarketTableComponent";
import { SparklesCore } from "../../../shared/animations/sparkles/soarklesCore";
import TimerComponent from "./components/timer";
import AnalysisPanelComponent from "./components/analysisPanelComponent";
import TransforMarket from "./components/TransforMarket";
import IframeComponent from "./components/iframeComponent";
import Challenges from "../day-1/components/Challengs";
import HeartBeat from "../../../shared/ui/hart-bit/HeartBeat";
import Logo5k from "./components/logo-motions/Logo5k";
import Logo10k from "./components/logo-motions/Logo10k";
import AhangariHolding from "./components/logo-motions/AhangariHolding";
import CloseAllPosition from "./components/logo-motions/CloseAllPosition";
import GoldenBuzzer from "./components/logo-motions/GoldenBuzzer";
import Winner from "./components/logo-motions/Winner";
import IronBear from "./components/logo-motions/IronBear";
import GoldenEagles from "./components/logo-motions/GoldenEagles";
import FeneFx from "./components/logo-motions/FeneFx";
import BullMasters from "./components/logo-motions/BullMaster";
import AlphaWolves from "./components/logo-motions/AlphaWolves";
import HouseOfTraders from "./components/logo-motions/HouseOfTraders";
import MondFine from "./components/logo-motions/MondFine";
import CapitanPage from "../day-2/components/capitans/CapitanPage";

export function GlobalDisplayComponent() {
  const [currentHtml, setCurrentHtml] = useState(null);
  const TABLE_DELAY_MS = 3000;
  const [canReveal, setCanReveal] = useState(false);
  const [showTablesNow, setShowTablesNow] = useState(false);
  const [tablesSessionKey, setTablesSessionKey] = useState(0);
  const revealTimerRef = useRef(null);
  const reduceMotion = useReducedMotion();
  const [showHeartbeat, setShowHeartbeat] = useState(false);
  const [heartbeatPayload, setHeartbeatPayload] = useState(null);
  const clearRevealTimer = () => {
    if (revealTimerRef.current) {
      clearTimeout(revealTimerRef.current);
      revealTimerRef.current = null;
    }
  };

  const prepareLayer = (mode) => {
    clearRevealTimer();
    setTablesSessionKey((k) => k + 1);
    setCanReveal(false);
    setShowTablesNow(false);
    setCurrentHtml(mode);
  };

  const startTableReveal = (mode) => {
    prepareLayer(mode);
    revealTimerRef.current = setTimeout(() => {
      setCanReveal(true);
      revealTimerRef.current = null;
    }, TABLE_DELAY_MS);
  };

  const startTableRevealWaitForData = (mode) => {
    prepareLayer(mode);
  };

  useOperatorActions("SHOW_AHANGARI_HOLDING", () => {
    clearRevealTimer();
    setCurrentHtml("AHANGARI_HOLDING_LOGO_DISPLAY");
    
  });
  useOperatorActions("SHOW_HOT_LOGO", () => {
    clearRevealTimer();
    setCurrentHtml("SHOW_HOT_LOGO");
          

  });
  useOperatorActions("SHOW_INTRO", () => {
    clearRevealTimer();
    setCurrentHtml("SHOW_INTRO");
          

  });
  useOperatorActions("SHOW_MOND_LOGO", () => {
    clearRevealTimer();
    setCurrentHtml("SHOW_MOND_LOGO");
          

  });
  useOperatorActions("SHOW_FENE_LOGO", () => {
    clearRevealTimer();
    setCurrentHtml("SHOW_FENE_LOGO");
          

  });
  useOperatorActions("SHOW_TRANSFORM_MARKET", () => {
    clearRevealTimer();
    setCurrentHtml("SHOW_TRANSFORM_MARKET");
          

  });
  useOperatorActions("SHOW_DESCRIPTION", () => {
    clearRevealTimer();
    setCurrentHtml("SHOW_DESCRIPTION");
          

  });
  useOperatorActions("SHOW_TABLE", () =>
    startTableRevealWaitForData("SHOW_TABLE"),
        

  );
  useOperatorActions("SHOW_TABLE_Realtime", () =>
    startTableReveal("SHOW_TABLE_Realtime"),
        

  );
  useOperatorActions("SHOW_TABLE_Final", () =>
    startTableReveal("SHOW_TABLE_Final"),
        

  );
  useOperatorActions("SHOW_TEAM_TABLE", () =>
    startTableReveal("SHOW_TEAM_TABLE"),
        

  );
  useOperatorActions("SHOW_USER_PANEL", () =>
    startTableReveal("SHOW_USER_PANEL"),
        

  );
  useOperatorActions("SHOW_TRANSFORM_MARKET_TABLE", () =>
    startTableReveal("SHOW_TRANSFORM_MARKET_TABLE"),
        

  );
  useOperatorActions("SHOW_DESCRIPTION", () =>
    startTableReveal("SHOW_DESCRIPTION"),
        

  );
  useOperatorActions("SHOW_LOGO_5K", () => startTableReveal("SHOW_LOGO_5K"),      
);
  useOperatorActions("SHOW_LOGO_10K", () => startTableReveal("SHOW_LOGO_10K"),      
);
  useOperatorActions("SHOW_LOGO_AHANGRAY_HOLDING_1", () =>
    startTableReveal("SHOW_LOGO_AHANGRAY_HOLDING_1"),
        

  );
  useOperatorActions("SHOW_LOGO_CLOSE_ALL_POSITION", () =>
    startTableReveal("SHOW_LOGO_CLOSE_ALL_POSITION"),
        

  );
  useOperatorActions("SHOW_LOGO_GOLDEN_BUZZER", () =>
    startTableReveal("SHOW_LOGO_GOLDEN_BUZZER"),
        

  );
  useOperatorActions("SHOW_LOGO_WINNER", () =>
    startTableReveal("SHOW_LOGO_WINNER"),
        

  );
  useOperatorActions("SHOW_LOGO_IRON_BEAR", () =>
    startTableReveal("SHOW_LOGO_IRON_BEAR"),
        

  );
  useOperatorActions("SHOW_LOGO_GOLDEN_EAGLES", () =>
    startTableReveal("SHOW_LOGO_GOLDEN_EAGLES"),
        

  );
  useOperatorActions("SHOW_LOGO_FENEFX", () =>
    startTableReveal("SHOW_LOGO_FENEFX"),
        

  );
  useOperatorActions("SHOW_LOGO_BULL_MASTERS", () =>
    startTableReveal("SHOW_LOGO_BULL_MASTERS"),
        

  );
  useOperatorActions("SHOW_DESCRIPTION", () =>
    startTableReveal("SHOW_DESCRIPTION"),
        

  );
  useOperatorActions("SHOW_LOGO_ALPHA_WOLVES", () =>
    startTableReveal("SHOW_LOGO_ALPHA_WOLVES"),
        

  );
  useOperatorActions("SHOW_LOGO_HOUSE_OF_TRADERS", () =>
    startTableReveal("SHOW_LOGO_HOUSE_OF_TRADERS"),
      

  );
  useOperatorActions("SHOW_LOGO_MOND_FINE", () =>
    startTableReveal("SHOW_LOGO_MOND_FINE"),
      

  );
  useOperatorActions("SHOW_ALL_CAPTAINS", () =>
    setCurrentHtml("SHOW_ALL_CAPTAINS"),
    

  );
  useOperatorActions("SHOW_IFRAME", () => startTableReveal("SHOW_IFRAME"));
  useOperatorActions("SHOW_TIMER", () => startTableReveal("SHOW_TIMER"));
  useOperatorActions("SHOW_HEARTBEAT", (payload) => {
    clearRevealTimer();
    setHeartbeatPayload(payload);
    setCurrentHtml("SHOW_HEARTBEAT")
    setShowHeartbeat(true);
  });
  const handleHeartbeatEnd = () => {
    setShowHeartbeat(!heartbeatPayload.payload.disapear);
  };
  useEffect(() => () => clearRevealTimer(), []);

  const variants = {
    initial: { opacity: 0, scale: 0.96, y: 12, filter: "blur(6px)" },
    animate: { opacity: 1, scale: 1, y: 0, filter: "blur(0px)" },
    exit: { opacity: 0, scale: 0.98, y: -8, filter: "blur(3px)" },
  };

  const renderTableLayer = (children, welcomeText) => (
    <div className="relative w-full flex items-center justify-center">
      <motion.div
        key={`tables-${tablesSessionKey}`}
        initial={{ opacity: 0, y: 8, scale: 0.98, filter: "blur(3px)" }}
        animate={
          showTablesNow
            ? { opacity: 1, y: 0, scale: 1, filter: "blur(0px)" }
            : { opacity: 0, y: 8, scale: 0.98, filter: "blur(3px)" }
        }
        transition={{ duration: 0.5, ease: [0.2, 0.8, 0.2, 1] }}
        aria-hidden={!showTablesNow}
        className={`w-full flex justify-center ${
          showTablesNow ? "pointer-events-auto" : "pointer-events-none"
        }`}
        style={
          showTablesNow
            ? {}
            : { position: "absolute", inset: 0, visibility: "hidden" }
        }
      >
        {showTablesNow && (
          <SparklesCore
            id="table-sparkles"
            background="transparent"
            minSize={0.6}
            maxSize={1.4}
            particleDensity={30}
            className="w-full h-full absolute top-[0] left-[50%] translate-x-[-50%] overflow-hidden"
            particleColor="#E8232C"
          />
        )}
        {children}
      </motion.div>

      <AnimatePresence
        onExitComplete={() => setShowTablesNow(true)}
        mode="wait"
      >
        {!canReveal && (
          <motion.div
            key="welcome-overlay"
            className="relative z-10"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <WelcomeComponent text={welcomeText} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );

  const renderCurrentHtml = (name) => {
    switch (name) {
      case "AHANGARI_HOLDING_LOGO_DISPLAY":
        return <AhangariHoldingLogoDisplayComponent />;
      case "SHOW_ALL_CAPTAINS":
        return <CapitanPage />;
      case "SHOW_HOT_LOGO":
        return <HotLogoDisplayComponent />;
      case "SHOW_MOND_LOGO":
        return <MondfxLogoDisplayComponent />;
      case "SHOW_FENE_LOGO":
        return <FenefxLogoDisplayComponent />;
      case "SHOW_INTRO":
        return <WelcomeComponent />;
      case "SHOW_USER_PANEL":
        return <AnalysisPanelComponent />;
      case "SHOW_IFRAME":
        return <IframeComponent />;
      case "SHOW_DESCRIPTION":
        return <Challenges />;
      case "SHOW_TRANSFORM_MARKET":
        return renderTableLayer(
          <div className="w-full flex flex-col lg:flex-row gap-8 items-start justify-center">
            <TransformMarketTableComponent
              onDataReady={() => setCanReveal(true)}
              play={showTablesNow}
            />
          </div>,
          "ترنسفر مارکت"
        );
      case "SHOW_TRANSFORM_MARKET_TABLE":
        return renderTableLayer(
          <div className="w-full h-full flex flex-col items-start justify-center">
            <TransforMarket
              onDataReady={() => setCanReveal(true)}
              play={showTablesNow}
            />
          </div>,
          "ترنسفر مارکت"
        );
      case "SHOW_TABLE":
        return renderTableLayer(
          <div className="w-full flex flex-col lg:flex-row gap-8 items-start justify-center">
            <PreviousChallangeLeaderBoardTableComponent
              onDataReady={() => setCanReveal(true)}
              play={showTablesNow}
            />
          </div>,
          "رده بندی مرحله سوم"
        );
      case "SHOW_TABLE_Realtime":
        return renderTableLayer(
          <div className="w-full flex flex-col lg:flex-row gap-8 items-start justify-center">
            <FirtChallangeLeaderBoardTableComponent play={showTablesNow} />
          </div>,
          "رده بندی انفرادی"
        );
      case "SHOW_TABLE_Final":
        return renderTableLayer(
          <div className="w-full flex flex-col lg:flex-row gap-8 items-start justify-center">
            <ResultTableComponent play={showTablesNow} />
          </div>,
          "رده بندی نهایی"
        );
      case "SHOW_TEAM_TABLE":
        return renderTableLayer(
          <div className="w-full flex flex-col lg:flex-row gap-8 items-start justify-center">
            <TeamLoaderBoardComponent play={showTablesNow} />
          </div>,
          "رده بندی تیمی"
        );
      case "SHOW_TIMER":
        return <TimerComponent />;
      case "SHOW_LOGO_5K":
        return <Logo5k />;
      case "SHOW_LOGO_10K":
        return <Logo10k />;
      case "SHOW_LOGO_AHANGRAY_HOLDING_1":
        return <AhangariHolding />;
      case "SHOW_LOGO_CLOSE_ALL_POSITION":
        return <CloseAllPosition />;
      case "SHOW_LOGO_GOLDEN_BUZZER":
        return <GoldenBuzzer />;
      case "SHOW_LOGO_WINNER":
        return <Winner />;
      case "SHOW_LOGO_IRON_BEAR":
        return <IronBear />;
      case "SHOW_LOGO_GOLDEN_EAGLES":
        return <GoldenEagles />;
      case "SHOW_LOGO_FENEFX":
        return <FeneFx />;
      case "SHOW_LOGO_BULL_MASTERS":
        return <BullMasters />;
      case "SHOW_LOGO_ALPHA_WOLVES":
        return <AlphaWolves />;
      case "SHOW_LOGO_HOUSE_OF_TRADERS":
        return <HouseOfTraders />;
      case "SHOW_LOGO_MOND_FINE":
        return <MondFine />;
      default:
        return (
          <div className="w-full h-[600px] text-white flex items-center justify-center">
            <WelcomeComponent />
          </div>
        );
    }
  };

  return (
    <>
      {showHeartbeat && currentHtml === "SHOW_HEARTBEAT" && (
        <HeartBeat payload={heartbeatPayload} onEnd={handleHeartbeatEnd} />
      )}
      {currentHtml === "SHOW_TIMER" ||
      currentHtml === "SHOW_IFRAME" ||
      currentHtml === "SHOW_DESCRIPTION" ||
      currentHtml === "SHOW_LOGO_5K" ||
      currentHtml === "SHOW_LOGO_10K" ||
      currentHtml === "SHOW_LOGO_AHANGRAY_HOLDING_1" ||
      currentHtml === "SHOW_LOGO_CLOSE_ALL_POSITION" ||
      currentHtml === "SHOW_LOGO_GOLDEN_BUZZER" ||
      currentHtml === "SHOW_LOGO_WINNER" ||
      currentHtml === "SHOW_LOGO_IRON_BEAR" ||
      currentHtml === "SHOW_LOGO_GOLDEN_EAGLES" ||
      currentHtml === "SHOW_LOGO_FENEFX" ||
      currentHtml === "SHOW_LOGO_BULL_MASTERS" ||
      currentHtml === "SHOW_LOGO_ALPHA_WOLVES" ||
      currentHtml === "SHOW_LOGO_HOUSE_OF_TRADERS" ||
      currentHtml === "SHOW_ALL_CAPTAINS" ||
      currentHtml === "SHOW_LOGO_MOND_FINE" ? (
        <div className=" w-full h-full ">{renderCurrentHtml(currentHtml)}</div>
      ) : (
        <CyberBoxComponent>
          <div className="w-screen h-screen flex items-center justify-center">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentHtml ?? "empty"}
                variants={reduceMotion ? undefined : variants}
                initial={reduceMotion ? false : "initial"}
                animate={reduceMotion ? undefined : "animate"}
                exit={reduceMotion ? undefined : "exit"}
                className="w-screen px-8"
                transition={{ duration: 0.6 }}
              >
                {renderCurrentHtml(currentHtml)}
              </motion.div>
            </AnimatePresence>
          </div>
        </CyberBoxComponent>
      )}
    </>
  );
}
